import { ButtonOverrides } from "baseui/button";
import { overrideStyles, OverrideStyles } from "@components/base/helpers";

export const buttonOverrides: ButtonOverrides = {
  BaseButton: {
    style: ({ $theme, $kind, $disabled }) => {
      const colors = defaultButtonColors({
        $disabled,
        $theme,
        $kind,
      });

      return {
        whiteSpace: "nowrap",
        fontFamily: "SourceSansPro-Bold!important",
        borderLeftWidth: "1px",
        borderRightWidth: "1px",
        borderTopWidth: "1px",
        borderBottomWidth: "1px",
        borderLeftStyle: "solid",
        borderTopStyle: "solid",
        borderRightStyle: "solid",
        borderBottomStyle: "solid",
        borderTopLeftRadius: $theme.borders.radius200,
        borderTopRightRadius: $theme.borders.radius200,
        borderBottomLeftRadius: $theme.borders.radius200,
        borderBottomRightRadius: $theme.borders.radius200,
        opacity: $disabled ? 0.4 : 1,
        animation: "none",
        ...colors,
        ...(!$disabled && {
          ":hover": {
            ...colors,
            opacity: 0.7,
          },
        }),
      };
    },
  },
  LoadingSpinner: {
    style: () => ({
      // Ensure only the spinner rotates, not the button
    }),
  },
};

export const overrideButtonStyles = (
  styles?: OverrideStyles<ButtonOverrides>,
) => {
  return overrideStyles<ButtonOverrides>({
    overrides: buttonOverrides,
    styles,
  });
};

export const generateButtonColors = ({
  $disabled,
  color,
  backgroundColor,
}: {
  $disabled: boolean;
  color?: string;
  backgroundColor?: string;
}) => {
  if ($disabled) {
    if (color !== undefined) color += "!important";
    if (backgroundColor !== undefined) backgroundColor += "!important";
  }

  return {
    ...(backgroundColor !== undefined && { backgroundColor }),
    ...(color !== undefined && {
      borderLeftColor: color,
      borderTopColor: color,
      borderRightColor: color,
      borderBottomColor: color,
      color,
    }),
  };
};

export const defaultButtonColors = ({
  $theme,
  $kind,
  $disabled,
}: {
  $theme: any;
  $kind?: "primary" | "secondary" | "tertiary";
  $disabled: boolean;
}) => {
  switch ($kind) {
    case "secondary":
      return generateButtonColors({
        $disabled,
        color: $theme.colors.buttonSecondaryText,
        backgroundColor: $theme.colors.buttonSecondaryFill,
      });

    case "tertiary":
      return generateButtonColors({
        $disabled,
        color: $theme.colors.white,
        backgroundColor: $theme.colors.buttonTertiaryFill,
      });

    case "primary":
    default:
      return generateButtonColors({
        $disabled,
        color: $theme.colors.buttonPrimaryText,
        backgroundColor: $theme.colors.buttonPrimaryFill,
      });
  }
};
